import { DEFAULT_SALES_ROOM_VISIBILITY_POLICY } from "../contracts/sales-room.js";
import { SalesRoomClientSafeSnapshotV1Schema, SalesRoomConfigV1Schema, SalesRoomProofStoryV1Schema, } from "../contracts/sales-room.js";
const CLIENT_SAFE_RELEASE_LABELS = {
    FULLY_GATED: "Quality checks passed with no material blockers.",
    CONDITIONALLY_RELEASED: "Your agency may proceed with documented exceptions.",
    ADVISORY_INCOMPLETE: "Some advisory checks need attention before launch.",
    BLOCKED: "Release is blocked until critical issues are resolved.",
};
function clientSafeReleaseLabelFor(label) {
    return CLIENT_SAFE_RELEASE_LABELS[label] ?? "Your project readiness is being reviewed.";
}
const READINESS_LABELS = {
    NEEDS_BASICS: "Needs Basics",
    ONE_PAGE_AVAILABLE: "One-Page Available",
    THREE_PAGE_AVAILABLE: "Three-Page Available",
    FIVE_PAGE_AVAILABLE: "Five-Page Available",
    STRONG_PROFILE_LARGER_LATER: "Strong Profile",
};
export function buildSalesRoomProofStory(input) {
    const blockers = input.qaStatus.checks
        .filter((c) => !c.passed &&
        c.checkClass === "CLASS_A" &&
        (c.severity === "BLOCKING" || c.severity === "FAIL"))
        .map(() => "A required check needs attention before launch.");
    const materialExceptions = input.qaStatus.exceptions.map(() => "A conditional exception applies to this project.");
    const story = SalesRoomProofStoryV1Schema.parse({
        schemaVersion: "sales-room-proof-story.v1.0",
        talkTrack: [
            "This summary reflects confirmed business information your agency verified.",
            "Quality checks help keep your preview safe and accurate before approval.",
        ],
        proofCards: input.readiness.availablePackages.map((pkg) => ({
            title: "Available package",
            body: `Your profile supports ${pkg.replace("package-", "").replace(/-/g, " ")}.`,
        })),
        summary: {
            schemaVersion: "sales-room-proof-summary.v1.0",
            headline: "Project readiness summary",
            readinessLabel: READINESS_LABELS[input.readiness.readinessLevel] ?? "Needs review",
            releaseLabel: clientSafeReleaseLabelFor(input.qaStatus.releaseLabel),
            proofHighlights: input.readiness.availablePackages.map((p) => `Package available: ${p.replace("package-", "")}`),
            blockers,
            warnings: [...input.readiness.warnings, ...materialExceptions],
        },
    });
    return SalesRoomClientSafeSnapshotV1Schema.parse({
        schemaVersion: "sales-room-client-safe-snapshot.v1.0",
        previewUrl: input.previewUrl,
        approvalEnabled: input.approvalEnabled && !input.staleArtifact && blockers.length === 0,
        staleArtifact: input.staleArtifact,
        proofStory: story,
    });
}
export const DEFAULT_SALES_ROOM_CONFIG = SalesRoomConfigV1Schema.parse({
    schemaVersion: "sales-room-config.v1.0",
    visibilityPolicy: DEFAULT_SALES_ROOM_VISIBILITY_POLICY,
    enabled: true,
});
//# sourceMappingURL=build-sales-room-snapshot.js.map